import { render, staticRenderFns } from "./RecentActivityTableDescriptionBookingRescheduled.vue?vue&type=template&id=5fac1e09&"
import script from "./RecentActivityTableDescriptionBookingRescheduled.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionBookingRescheduled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports